// extracted by mini-css-extract-plugin
export default {"container":"Reconnect__container--1C2","content":"Reconnect__content--3z1","button":"Reconnect__button--3Xs"};